import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { AdminLayout } from 'src/layouts/admin';
import { lazyRetry } from 'src/utils/lazyRetry';
import { SplashScreen } from 'src/components/loading-screen';
import { AdminGuard, AdminGuestGuard } from 'src/auth/guard';
import AdminStoreProvider from 'src/redux/admin/AdminStoreProvider';

const FiatBalancePage = lazyRetry(() => import('src/pages/admin/FiatBalance'));
const ForgotPasswordPage = lazyRetry(() => import('src/pages/admin/ForgetPassword'));
const AdminLoginPage = lazyRetry(() => import('src/pages/admin/AdminLogin'));
const AdminVerifyTocPage = lazyRetry(() => import('src/pages/admin/AdminVerifyToc'));
const DashboardPage = lazyRetry(() => import('src/pages/admin/Dashboard'));
const SettingsPage = lazyRetry(() => import('src/pages/admin/Settings'));
const AdminTransactionsPage = lazyRetry(() => import('src/pages/admin/AdminTransactions'));
const AdminOnchainTransactionsPage = lazyRetry(() => import('src/pages/admin/OnchainTransactions'));
const AdminUsersPage = lazyRetry(() => import('src/pages/admin/Users'));
const UsersProfilePage = lazyRetry(() => import('src/pages/admin/UsersProfilePage'));
const TransactionStatusPage = lazyRetry(() => import('src/pages/TransactionStatus'));
const CreateAdminUserPage = lazyRetry(() => import('src/pages/admin/adminList'));
const LPUsersPage = lazyRetry(() => import('src/pages/admin/LPUsersPage'));
const LPUserProfilePage = lazyRetry(() => import('src/pages/admin/LPProfilePage'));

export const getAdminRoutes = () => {
  return [
    {
      element: (
        <AdminStoreProvider>
          <Suspense fallback={<SplashScreen />}>
            <Outlet />
          </Suspense>
        </AdminStoreProvider>
      ),
      children: [
        {
          index: true,
          element: <Navigate to="login" replace />,
        },

        // Public admin auth pages
        {
          path: 'login',
          element: (
            <AdminGuestGuard>
              <AdminLoginPage />
            </AdminGuestGuard>
          ),
        },

        {
          path: 'verify-toc',
          element: <AdminVerifyTocPage />,
        },
        {
          path: 'forget-password',
          element: <ForgotPasswordPage />,
        },

        // Protected admin pages
        {
          element: (
            <AdminGuard>
              <AdminLayout>
                <Suspense fallback={<SplashScreen />}>
                  <Outlet />
                </Suspense>
              </AdminLayout>
            </AdminGuard>
          ),
          children: [
            { path: 'dashboard', element: <DashboardPage /> },
            { path: 'settings', element: <SettingsPage /> },
            { path: 'transactions', element: <AdminTransactionsPage /> },
            { path: 'onchain-transactions', element: <AdminOnchainTransactionsPage /> },
            { path: 'fiat-balance', element: <FiatBalancePage /> },
            { path: 'create', element: <CreateAdminUserPage /> },
            { path: 'transaction/:id', element: <TransactionStatusPage admin /> },
            { path: 'users', element: <AdminUsersPage /> },
            { path: 'lp-users', element: <LPUsersPage /> },
            { path: 'lp-users/:id', element: <LPUserProfilePage /> },
            { path: 'users/:phoneNumber', element: <UsersProfilePage /> },
          ],
        },
      ],
    },
  ];
};
